import {DomainEvent} from './DomainEvent';
import {DeletedUser} from '../resources/DeletedUser';

export class UserSoftDeleted extends DomainEvent<DeletedUser> {}
